import React from 'react';
import {isString} from 'lodash';
import {
  removeWfTokens,
  removeAllTokens,
} from '@packages/systems/core/utils/EmbedUtils/all';
import {trimmedOneLiner} from '@packages/utilities/string-utils';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {Atom, AtomRenderProps, StyleAttributeImm} from '@packages/systems/wfdl';
import {TRecord, TBoolean} from '@packages/systems/wfdl-ast';
import {
  EvaluatedNodeData,
  getBoolean,
  getInPojo,
} from '@packages/utilities/data-utils';
import {useRuntimeEnvironment} from '@packages/systems/render';

const handleStaticContent = (
  content: string | StyleAttributeImm,
  data: EvaluatedNodeData,
  exportMode: boolean
) => {
  return !exportMode && getBoolean(getInPojo(data, ['shouldReplaceTokens']))
    ? removeAllTokens(content)
    : removeWfTokens(content || '');
};

const Meta = Atom.createRender(
  ({attributes, classes, generateAttributes, token, data}: AtomRenderProps) => {
    const runtimeEnvironment = useRuntimeEnvironment();
    const exportMode = runtimeEnvironment === WebflowEnvironments.EXPORT;
    const newAttributes = attributes.update('content', '', (content) => {
      const value = isString(token)
        ? token
        : handleStaticContent(content, data, exportMode);
      return trimmedOneLiner(value);
    });
    return <meta {...generateAttributes(newAttributes, classes)} />;
  }
);

const config = Atom.create({
  showEmpty: false,
  render: Meta,
  pathToReplaceableString: ['attr', 'content'],
  dataType: TRecord({shouldReplaceTokens: TBoolean}),
});

export default config;
